/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignMasterKeyRequest,
  AssignPidRequest,
  ChangeMpkRequest,
  GetAdUsersResponse,
  GetAuthorizationDataResponse,
  GetNdpClientContractsRequest,
  GetNdpClientContractsResponse,
  GetODSClientsResponse,
  GetRegisteredUsersResponse,
  ImpersonateUserRequest,
  UpdateAuthorizationPropertyRequest,
  UpdateAuthorizationPropertyResponse,
} from '../models/index';
import {
    AssignMasterKeyRequestFromJSON,
    AssignMasterKeyRequestToJSON,
    AssignPidRequestFromJSON,
    AssignPidRequestToJSON,
    ChangeMpkRequestFromJSON,
    ChangeMpkRequestToJSON,
    GetAdUsersResponseFromJSON,
    GetAdUsersResponseToJSON,
    GetAuthorizationDataResponseFromJSON,
    GetAuthorizationDataResponseToJSON,
    GetNdpClientContractsRequestFromJSON,
    GetNdpClientContractsRequestToJSON,
    GetNdpClientContractsResponseFromJSON,
    GetNdpClientContractsResponseToJSON,
    GetODSClientsResponseFromJSON,
    GetODSClientsResponseToJSON,
    GetRegisteredUsersResponseFromJSON,
    GetRegisteredUsersResponseToJSON,
    ImpersonateUserRequestFromJSON,
    ImpersonateUserRequestToJSON,
    UpdateAuthorizationPropertyRequestFromJSON,
    UpdateAuthorizationPropertyRequestToJSON,
    UpdateAuthorizationPropertyResponseFromJSON,
    UpdateAuthorizationPropertyResponseToJSON,
} from '../models/index';

export interface AssignMasterKeyPatchRequest {
    assignMasterKeyRequest: AssignMasterKeyRequest;
}

export interface AssignPidPatchRequest {
    assignPidRequest: AssignPidRequest;
}

export interface ChangeMpkPatchRequest {
    changeMpkRequest: ChangeMpkRequest;
}

export interface GetAdUsersGetRequest {
    search?: string;
}

export interface GetAuthorizationDataGetRequest {
    mpk?: string;
}

export interface GetNdpClientContractsPostRequest {
    getNdpClientContractsRequest?: GetNdpClientContractsRequest;
}

export interface GetODSClientsGetRequest {
    birthNumber?: string;
    contractNumber?: string;
}

export interface GetRegisteredUsersGetRequest {
    search?: string;
    count?: number;
    pageNumber?: number;
}

export interface ImpersonateUserPostRequest {
    impersonateUserRequest?: ImpersonateUserRequest;
}

export interface RemoveAdUserDeleteRequest {
    userId: string;
    employeeId?: string;
}

export interface UpdateAuthorizationPropertyPatchRequest {
    updateAuthorizationPropertyRequest: UpdateAuthorizationPropertyRequest;
}

/**
 * 
 */
export class CallCenterApi extends runtime.BaseAPI {

    /**
     * Assign MasterKey to a Active Directory user.
     * @deprecated
     */
    async assignMasterKeyPatchRaw(requestParameters: AssignMasterKeyPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assignMasterKeyRequest'] == null) {
            throw new runtime.RequiredError(
                'assignMasterKeyRequest',
                'Required parameter "assignMasterKeyRequest" was null or undefined when calling assignMasterKeyPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/assign-masterkey`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AssignMasterKeyRequestToJSON(requestParameters['assignMasterKeyRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Assign MasterKey to a Active Directory user.
     * @deprecated
     */
    async assignMasterKeyPatch(requestParameters: AssignMasterKeyPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assignMasterKeyPatchRaw(requestParameters, initOverrides);
    }

    /**
     * Assign Pid to a Active Directory user.
     * @deprecated
     */
    async assignPidPatchRaw(requestParameters: AssignPidPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assignPidRequest'] == null) {
            throw new runtime.RequiredError(
                'assignPidRequest',
                'Required parameter "assignPidRequest" was null or undefined when calling assignPidPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/assign-pid`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AssignPidRequestToJSON(requestParameters['assignPidRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Assign Pid to a Active Directory user.
     * @deprecated
     */
    async assignPidPatch(requestParameters: AssignPidPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assignPidPatchRaw(requestParameters, initOverrides);
    }

    /**
     * Change MPK for a registered user.
     * @deprecated
     */
    async changeMpkPatchRaw(requestParameters: ChangeMpkPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['changeMpkRequest'] == null) {
            throw new runtime.RequiredError(
                'changeMpkRequest',
                'Required parameter "changeMpkRequest" was null or undefined when calling changeMpkPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/change-mpk`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeMpkRequestToJSON(requestParameters['changeMpkRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Change MPK for a registered user.
     * @deprecated
     */
    async changeMpkPatch(requestParameters: ChangeMpkPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.changeMpkPatchRaw(requestParameters, initOverrides);
    }

    /**
     * Get list of current users.
     * @deprecated
     */
    async getAdUsersGetRaw(requestParameters: GetAdUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAdUsersResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ad-users`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAdUsersResponseFromJSON));
    }

    /**
     * Get list of current users.
     * @deprecated
     */
    async getAdUsersGet(requestParameters: GetAdUsersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAdUsersResponse>> {
        const response = await this.getAdUsersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get current authorization phone and email by MPK.
     */
    async getAuthorizationDataGetRaw(requestParameters: GetAuthorizationDataGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAuthorizationDataResponse>> {
        const queryParameters: any = {};

        if (requestParameters['mpk'] != null) {
            queryParameters['Mpk'] = requestParameters['mpk'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("EntraIdCallCenterFlow", ["api://cd099b5e-8cc8-4f38-b7d7-d7f0278fff2d/CallCenter.Access"]);
        }


        let urlPath = `/authorization-property`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAuthorizationDataResponseFromJSON(jsonValue));
    }

    /**
     * Get current authorization phone and email by MPK.
     */
    async getAuthorizationDataGet(requestParameters: GetAuthorizationDataGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAuthorizationDataResponse> {
        const response = await this.getAuthorizationDataGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of Ndp clients based on search parameter.
     * @deprecated
     */
    async getNdpClientContractsPostRaw(requestParameters: GetNdpClientContractsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetNdpClientContractsResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/ndp-clients`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetNdpClientContractsRequestToJSON(requestParameters['getNdpClientContractsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetNdpClientContractsResponseFromJSON));
    }

    /**
     * Get list of Ndp clients based on search parameter.
     * @deprecated
     */
    async getNdpClientContractsPost(requestParameters: GetNdpClientContractsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetNdpClientContractsResponse>> {
        const response = await this.getNdpClientContractsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of clients based on search parameter.
     * @deprecated
     */
    async getODSClientsGetRaw(requestParameters: GetODSClientsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetODSClientsResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['birthNumber'] != null) {
            queryParameters['birthNumber'] = requestParameters['birthNumber'];
        }

        if (requestParameters['contractNumber'] != null) {
            queryParameters['contractNumber'] = requestParameters['contractNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ods-clients`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetODSClientsResponseFromJSON));
    }

    /**
     * Get list of clients based on search parameter.
     * @deprecated
     */
    async getODSClientsGet(requestParameters: GetODSClientsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetODSClientsResponse>> {
        const response = await this.getODSClientsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of registered users.
     * @deprecated
     */
    async getRegisteredUsersGetRaw(requestParameters: GetRegisteredUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRegisteredUsersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['Search'] = requestParameters['search'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['Count'] = requestParameters['count'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/registered-users`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRegisteredUsersResponseFromJSON(jsonValue));
    }

    /**
     * Get list of registered users.
     * @deprecated
     */
    async getRegisteredUsersGet(requestParameters: GetRegisteredUsersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRegisteredUsersResponse> {
        const response = await this.getRegisteredUsersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get impersonated user from the registered table.
     * @deprecated
     */
    async impersonateUserPostRaw(requestParameters: ImpersonateUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/impersonate-user`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImpersonateUserRequestToJSON(requestParameters['impersonateUserRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get impersonated user from the registered table.
     * @deprecated
     */
    async impersonateUserPost(requestParameters: ImpersonateUserPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.impersonateUserPostRaw(requestParameters, initOverrides);
    }

    /**
     * Remove user from Active Directory
     * @deprecated
     */
    async removeAdUserDeleteRaw(requestParameters: RemoveAdUserDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling removeAdUserDelete().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employeeId'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ad-users/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove user from Active Directory
     * @deprecated
     */
    async removeAdUserDelete(requestParameters: RemoveAdUserDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeAdUserDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Create authorization property change request by MPK.
     */
    async updateAuthorizationPropertyPatchRaw(requestParameters: UpdateAuthorizationPropertyPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateAuthorizationPropertyResponse>> {
        if (requestParameters['updateAuthorizationPropertyRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAuthorizationPropertyRequest',
                'Required parameter "updateAuthorizationPropertyRequest" was null or undefined when calling updateAuthorizationPropertyPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("EntraIdCallCenterFlow", ["api://cd099b5e-8cc8-4f38-b7d7-d7f0278fff2d/CallCenter.Access"]);
        }


        let urlPath = `/authorization-property`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAuthorizationPropertyRequestToJSON(requestParameters['updateAuthorizationPropertyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateAuthorizationPropertyResponseFromJSON(jsonValue));
    }

    /**
     * Create authorization property change request by MPK.
     */
    async updateAuthorizationPropertyPatch(requestParameters: UpdateAuthorizationPropertyPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateAuthorizationPropertyResponse> {
        const response = await this.updateAuthorizationPropertyPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
